/** Backend PRIORITY_CHOICES — order low → high for selects. */
export const TASK_PRIORITY_ORDER = ["lowest", "low", "medium", "high", "highest"];

export const TASK_PRIORITY_META = {
  lowest: { label: "Lowest", color: "#0369A1" },
  low: { label: "Low", color: "#1D4ED8" },
  medium: { label: "Medium", color: "#D4A012" },
  high: { label: "High", color: "#EA580C" },
  highest: { label: "Highest", color: "#E11D48" },
};

export const TASK_PRIORITY_NULL_COLOR = "#9E9E9E";

const TASK_PRIORITY_TEXT_COLOR = {
  lowest: "#FFFFFF",
  low: "#FFFFFF",
  medium: "#FFFFFF",
  high: "#FFFFFF",
  highest: "#FFFFFF",
};

export const TASK_PRIORITY_EMPTY_LABEL = "—";

export const TASK_PRIORITY_SELECT_OPTIONS = TASK_PRIORITY_ORDER.map((value) => ({
  id: value,
  name: TASK_PRIORITY_META[value].label,
  value,
}));

/** First option clears priority (sends null to API). */
export const TASK_PRIORITY_SELECT_OPTIONS_WITH_EMPTY = [
  { id: "", name: TASK_PRIORITY_EMPTY_LABEL, value: "" },
  ...TASK_PRIORITY_SELECT_OPTIONS,
];

/**
 * @param {unknown} raw
 * @returns {'lowest'|'low'|'medium'|'high'|'highest'|null}
 */
export function normalizeTaskPriority(raw) {
  if (raw == null || String(raw).trim() === "") return null;
  const key = String(raw).trim().toLowerCase();
  return TASK_PRIORITY_META[key] ? key : null;
}

export function getTaskPriorityLabel(priority) {
  const key = normalizeTaskPriority(priority);
  if (!key) return TASK_PRIORITY_EMPTY_LABEL;
  return TASK_PRIORITY_META[key].label;
}

export function getTaskPriorityColors(priority) {
  const key = normalizeTaskPriority(priority);
  if (!key) {
    return {
      backgroundColor: TASK_PRIORITY_NULL_COLOR,
      color: "#FFFFFF",
    };
  }
  return {
    backgroundColor: TASK_PRIORITY_META[key].color,
    color: TASK_PRIORITY_TEXT_COLOR[key] ?? "#FFFFFF",
  };
}

/** @param {unknown} priority */
export function resolveTaskPriorityPayload(priority) {
  return normalizeTaskPriority(priority);
}

/** Numeric rank for table sorting (null/empty = 0, then lowest → highest). */
const PRIORITY_SORT_RANK = {
  lowest: 1,
  low: 2,
  medium: 3,
  high: 4,
  highest: 5,
};

export function getTaskPrioritySortRank(priority) {
  const key = normalizeTaskPriority(priority);
  if (!key) return 0;
  return PRIORITY_SORT_RANK[key] ?? 0;
}
